module.exports = __webpack_public_path__ + "static/img/hot-sale.dfcc0d2e.png";